var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import useStore from './../store.js';
import shallow from 'zustand/shallow';
import styled from 'styled-components';
import useCategorizedIndicators from '../App/hooks/useCategorizedIndicators.js';
import IndicatorList from '../Indicators/IndicatorList.js';

var FilterSeries = function FilterSeries(_ref) {
  var props = _extends({}, _ref); // console.log('FilterSeries, tab = ', props)


  var _useStore = useStore(function (_ref2) {
    var activeLayers = _ref2.activeLayers,
        indicators = _ref2.indicators,
        interactionsMobile = _ref2.interactionsMobile,
        setStoreValues = _ref2.setStoreValues,
        activeMetric = _ref2.activeMetric;
    return {
      activeLayers: activeLayers,
      indicators: indicators,
      interactionsMobile: interactionsMobile,
      setStoreValues: setStoreValues,
      activeMetric: activeMetric
    };
  }, shallow),
      interactionsMobile = _useStore.interactionsMobile,
      setStoreValues = _useStore.setStoreValues,
      activeMetric = _useStore.activeMetric;

  var indicatorsByCategory = useCategorizedIndicators();
  if (indicatorsByCategory.length === 0) return i18n.translate("MAP_FILTERS_SELECT_NONE");

  var handleIndicatorSelect = function handleIndicatorSelect(indicator) {
    setStoreValues({
      activeMetric: indicator.id
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, indicatorsByCategory.map(function (_ref3) {
    var name = _ref3.name,
        indicators = _ref3.indicators;
    return /*#__PURE__*/React.createElement(CategoryWrapper, {
      key: name
    }, /*#__PURE__*/React.createElement("h3", {
      className: "gotham16"
    }, name), /*#__PURE__*/React.createElement(IndicatorList, {
      indicators: indicators,
      showHints: !interactionsMobile,
      onSelect: handleIndicatorSelect,
      activeId: activeMetric
    }));
  }));
};

var CategoryWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 2rem;\n  .list-group {\n    margin-top: 1.2rem;\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n"])));
FilterSeries.defaultProps = {
  tab: '',
  metrics: []
};
export default FilterSeries;